"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../core/button"));
var _edit = _interopRequireDefault(require("../../../../icons/edit"));
var _newApplication = _interopRequireDefault(require("./new-application"));
var _viewApplication = _interopRequireDefault(require("./view-application"));
var _calendarDateEdit = _interopRequireDefault(require("./calendar-date-edit"));
var _applicationSpecials = _interopRequireDefault(require("./application-specials"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement(_edit.default, null);
class CalendarRow extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      editingCalendarDate: false
    });
    _defineProperty(this, "_getTierApplications", divID => {
      return this.props.applicationRacing.filter(divRace => divRace.tierRef === divID);
    });
    // Specials where the type of special not yet defined
    _defineProperty(this, "_getUndeclaredSpecials", () => {
      return this.props.applicationRacing.filter(divRace => divRace.tierRef === 'SPCL' && !this.props.applicationSpecials.some(special => special.applicationID === divRace.applicationID));
    });
    _defineProperty(this, "_onToggleCalendarDateEdit", () => {
      this.setState({
        editingCalendarDate: !this.state.editingCalendarDate
      });
    });
  }
  render() {
    const calendarDate = this.props.calendarDate;
    const weekBreakStyle = this.props.weekBreakStyle;
    const calSpecialsText = this.props.calendarSpecials.map(special => special.calendarSpecialLabel).join(', ');
    if (calendarDate) {
      return /*#__PURE__*/_react.default.createElement("tr", null, !this.state.editingCalendarDate ? null : /*#__PURE__*/_react.default.createElement(_calendarDateEdit.default, {
        calendarDate: calendarDate,
        calendarSpecials: this.props.calendarSpecials,
        onCloseCancel: this._onToggleCalendarDateEdit
      }), !this.props.isEditingCalendar ? null : /*#__PURE__*/_react.default.createElement("td", {
        style: {
          borderLeftColor: 'transparent',
          borderBottomColor: 'transparent'
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: this._onToggleCalendarDateEdit,
        type: "default",
        style: {
          paddingRight: '0.1rem',
          paddingLeft: '0.1rem'
        }
      }, _ref)), /*#__PURE__*/_react.default.createElement("td", {
        style: weekBreakStyle
      }, /*#__PURE__*/_react.default.createElement(_newApplication.default, {
        calendarDate: calendarDate,
        calendar: this.props.calendar,
        userIsCalendarOfficer: this.props.userIsCalendarOfficer
      })), this.props.tiers.filter(t => t.tierRef !== 'SPCL').map(t => /*#__PURE__*/_react.default.createElement("td", {
        style: !calendarDate.blockedTiers.includes(t.tierRef) ? weekBreakStyle : {
          backgroundColor: '#cbcbcc',
          ...weekBreakStyle
        },
        key: t.id
      }, this._getTierApplications(t.tierRef).map(divRace => /*#__PURE__*/_react.default.createElement(_viewApplication.default, {
        divRace: divRace,
        key: divRace.id,
        calendar: this.props.calendar,
        userIsCalendarOfficer: this.props.userIsCalendarOfficer
      })))), /*#__PURE__*/_react.default.createElement("td", {
        style: weekBreakStyle
      }, this._getUndeclaredSpecials().map(divRace => /*#__PURE__*/_react.default.createElement(_viewApplication.default, {
        divRace: divRace,
        key: divRace.id,
        calendar: this.props.calendar,
        userIsCalendarOfficer: this.props.userIsCalendarOfficer
      })), /*#__PURE__*/_react.default.createElement(_applicationSpecials.default, {
        applicationSpecials: this.props.applicationSpecials
      }), !calSpecialsText ? null : /*#__PURE__*/_react.default.createElement("p", null, calSpecialsText)));
    }
  }

  // *******************************************************************************
  // Partial Queries
  // *******************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CalendarRow, "partialQueries", {
  Calendar: _mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries(_mergeBqlQueries({
    applicationRacing: {
      id: true,
      tierRef: true,
      application: {
        id: true
      }
    },
    calendarSpecials: {
      id: true,
      calendarSpecialLabel: true
    },
    calendarDates: {
      blockedTiers: true
    }
  }, _newApplication.default.partialQueries.Calendar), _viewApplication.default.partialQueries.Calendar), _applicationSpecials.default.partialQueries.Calendar), _calendarDateEdit.default.partialQueries.Calendar)
});
var _default = exports.default = CalendarRow;